import { FETCH_CONFIG, API_BASE_URL } from "./constants";
import { API } from "app/api";

export const fetchConfig = () => ({
  type: API,
  payload: {
    request: `${API_BASE_URL}/resources/conf`,
    ...FETCH_CONFIG
  }
});



// WEBPACK FOOTER //
// ./src/app/config/actions.js